import { captureException } from '@sentry/vue'
import type { AxiosError } from 'axios'

export default (error: AxiosError) => {
  const status = error?.response?.status

  const handledStatuses = [401]

  if (!status || !handledStatuses.includes(status)) {
    captureException(error)
  }

  return Promise.reject(error)
}
